<script>
  import SmallTitle from '../../common/SmallTitle.svelte';

  export let value;
  export let lang = undefined;

  const i18n = {
    umpires: {
      cs: 'Rozhodčí',
      en: 'Umpires',
    },
    scorers: {
      cs: 'Zapisovatelé',
      en: 'Scorers',
    },
    commissioners: {
      cs: 'Komisaři',
      en: 'Commissioners',
    },
  };
</script>

<div class='game-officials'>
  {#if value.umpires.length > 0}
    <div class='game-officials-umpires'>
      <SmallTitle value={i18n.umpires[lang]} small={true}/>

      <div class='game-officials-umpires-value'>
        {value.umpires.join(', ')}
      </div>
    </div>
  {/if}

  {#if value.scorers.length > 0}
    <div class='game-officials-scorers'>
      <SmallTitle value={i18n.scorers[lang]} small={true}/>

      <div class='game-officials-scorers-value'>
        {value.scorers.join(', ')}
      </div>
    </div>
  {/if}

  {#if value.commissioners.length > 0}
    <div class='game-officials-commissioners'>
      <SmallTitle value={i18n.commissioners[lang]} small={true}/>

      <div class='game-officials-commissioners-value'>
        {value.commissioners.join(', ')}
      </div>
    </div>
  {/if}
</div>

<style>
  .game-officials {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .game-officials-umpires,
  .game-officials-scorers,
  .game-officials-commissioners {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .game-officials-umpires-value,
  .game-officials-scorers-value,
  .game-officials-commissioners-value {
    line-height: 1.25;
  }
</style>
